<template>
    <transition name="searchbox"
    v-on:before-leave="beforeLeave"
    v-on:after-leave="afterLeave"
    >
        <form class="search" v-show="isVisible">
            <div class="field-group">
                <input autofocus
                       class="search-field"
                       :class="{'is-closing' : isClosing}"
                       placeholder="Suchen"
                       ref="search"
                       type="text"
                       v-focus
                       v-on:input="search = $event.target.value" />
                <button class="search-button icon-suche"></button>
            </div>
        </form>
    </transition>
</template>

<script>
	export default {
		name: "Search",
		data() {
			return {
				search: '',
                isClosing: false,
				// isVisible : false
			};
		},
        props: ['isVisible'],
        // props : {
		// 	isVisible : {
		// 		type : Boolean,
        //         default : false
        //     }
        // },
        directives : {
			focus : {
				update : function( el ) {
					el.focus();
                }
            }
        },
		methods: {
			beforeLeave : function() {
				this.isClosing = true;
            },
			afterLeave : function() {
				this.isClosing = false;
            },
			closeSearch: function () {
				this.search = '';
				this.isClosing = false;
				Events.$emit('closeSearch');
			},
            afterAnimation : function( evt ) {
				// console.log( evt );
				if( this.isClosing ) {
					this.closeSearch();
				}

				this.focusField();
            },
            focusField: function ( ) {
                setTimeout(function () {
                    // console.log( this );
                    this.$refs.search.focus();
                }.bind(this), 20);
            },
			triggerSearch: function () {
				Events.$emit('fullTextSearch', this.search);
			}
		},
		watch: {
			search: function ( val ) {
				Events.$emit('fullTextSearch', val);
			}
		},
		mounted() {
			// Events.$on( 'overlay:closed', () => this.isClosing = true);
			document.querySelector('[autofocus]').click();
		}
	};
</script>

<style scoped>



</style>


// WEBPACK FOOTER //
// src/components/subparts/Search.vue